/* yy-stories.js - abre em tela cheia os vídeos das bolinhas (marcação em snippets/product-story-bubbles.liquid).
   Um único player é reaproveitado; navega por toque/clique nas laterais, seta no teclado ou passa sozinho ao acabar o vídeo.
   Também monta, por cima do vídeo: o cartão do produto (preço/Pix/parcelas e Adicionar ao carrinho, com a
   folha de variações quando há mais de uma cor) e os ícones de favoritar/compartilhar. */
(function () {
  if (window.__yyStories) return;
  window.__yyStories = true;

  var sv = null; /* elementos do player, criados na primeira abertura */
  var items = [];
  var index = 0;
  var product = null;
  var preferMuted = false;
  var dragStartY = null;

  function money(cents) {
    return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents, window.money_format) : cents;
  }

  function pickSource(sources) {
    if (!sources || !sources.length) return null;
    var sorted = sources.slice().sort(function (a, b) { return a.width - b.width; });
    var target = Math.min(window.innerWidth || 400, 480);
    var best = sorted[0];
    for (var i = 0; i < sorted.length; i++) {
      if (sorted[i].width <= target * 1.3) best = sorted[i];
    }
    return best.url;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  function build() {
    var root = document.createElement('div');
    root.className = 'yy-sv';
    root.innerHTML =
      '<div class="yy-sv__backdrop" data-yy-sv-backdrop></div>' +
      '<div class="yy-sv__stage" data-yy-sv-stage>' +
      '<div class="yy-sv__bars" data-yy-sv-bars></div>' +
      '<div class="yy-sv__head">' +
      '<span class="yy-sv__title" data-yy-sv-title></span>' +
      '<span class="yy-sv__actions">' +
      '<button type="button" class="yy-sv__btn" data-yy-sv-mute aria-label="Som"><i class="feather-volume-2"></i></button>' +
      '<button type="button" class="yy-sv__btn" data-yy-sv-close aria-label="Fechar"><i class="feather-x"></i></button>' +
      '</span>' +
      '</div>' +
      '<video class="yy-sv__video" data-yy-sv-video playsinline webkit-playsinline></video>' +
      '<div class="yy-sv__spinner" aria-hidden="true"></div>' +
      '<div class="yy-sv__zone yy-sv__zone--prev" data-yy-sv-prev></div>' +
      '<div class="yy-sv__zone yy-sv__zone--next" data-yy-sv-next></div>' +
      '<div class="yy-sv__side" data-yy-sv-side>' +
      '<a href="#" class="yy-sv__side-btn wishlist-custom-action wishlist" data-yy-sv-heart aria-label="Favoritar"><i class="feather-heart"></i></a>' +
      '<a href="#" target="_blank" rel="noopener" class="yy-sv__side-btn yy-sv__side-btn--wa" data-yy-sv-whatsapp aria-label="Compartilhar no WhatsApp">' +
      '<svg viewBox="0 0 448 512" width="20" height="20" aria-hidden="true"><path fill="#fff" d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/></svg>' +
      '</a>' +
      '<span style="position:relative">' +
      '<button type="button" class="yy-sv__side-btn" data-yy-sv-share aria-label="Compartilhar"><i class="feather-share-2"></i></button>' +
      '<span class="yy-sv__side-toast" data-yy-sv-toast>Link copiado</span>' +
      '</span>' +
      '</div>' +
      '<div class="yy-sv__card" data-yy-sv-card>' +
      '<div class="yy-sv__card-top">' +
      '<img class="yy-sv__card-img" data-yy-sv-card-img alt="">' +
      '<div class="yy-sv__card-info">' +
      '<div class="yy-sv__card-title" data-yy-sv-card-title></div>' +
      '<div data-yy-sv-price></div>' +
      '</div>' +
      '</div>' +
      '<button type="button" class="yy-sv__card-btn" data-yy-sv-add>' +
      '<span data-yy-sv-add-label>Adicionar ao carrinho</span>' +
      '<i class="feather-shopping-bag" aria-hidden="true"></i>' +
      '<span class="yy-sv__card-spinner" aria-hidden="true"></span>' +
      '</button>' +
      '</div>' +
      '<div class="yy-sv__sheet" data-yy-sv-sheet>' +
      '<div class="yy-sv__sheet-panel" data-yy-sv-sheet-panel>' +
      '<div class="yy-sv__sheet-head">' +
      '<span class="yy-sv__sheet-title">Escolha a variação</span>' +
      '<button type="button" class="yy-sv__sheet-close" data-yy-sv-sheet-close aria-label="Fechar"><i class="feather-x"></i></button>' +
      '</div>' +
      '<div class="yy-sv__sheet-grid" data-yy-sv-sheet-grid></div>' +
      '</div>' +
      '</div>' +
      '</div>';
    document.body.appendChild(root);

    var video = root.querySelector('[data-yy-sv-video]');
    var stage = root.querySelector('[data-yy-sv-stage]');

    video.addEventListener('timeupdate', updateProgress);
    video.addEventListener('ended', function () { goTo(index + 1); });
    video.addEventListener('waiting', function () { root.setAttribute('data-yy-sv-loading', ''); });
    video.addEventListener('playing', function () { root.removeAttribute('data-yy-sv-loading'); });

    root.querySelector('[data-yy-sv-backdrop]').addEventListener('click', close);
    root.querySelector('[data-yy-sv-close]').addEventListener('click', function (e) { e.stopPropagation(); close(); });
    root.querySelector('[data-yy-sv-mute]').addEventListener('click', function (e) {
      e.stopPropagation();
      preferMuted = !preferMuted;
      applyMute();
    });
    root.querySelector('[data-yy-sv-prev]').addEventListener('click', function () { goTo(index - 1); });
    root.querySelector('[data-yy-sv-next]').addEventListener('click', function () { goTo(index + 1); });

    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) dragStartY = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      if (dragStartY === null) return;
      var dy = e.touches[0].clientY - dragStartY;
      if (dy > 0) stage.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (dragStartY === null) return;
      var dy = (e.changedTouches[0].clientY - dragStartY);
      stage.style.transform = '';
      dragStartY = null;
      if (dy > 90) close();
    });

    document.addEventListener('keydown', function (e) {
      if (!root.hasAttribute('data-yy-sv-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') goTo(index - 1);
      else if (e.key === 'ArrowRight') goTo(index + 1);
    });

    var whatsapp = root.querySelector('[data-yy-sv-whatsapp]');
    var shareBtn = root.querySelector('[data-yy-sv-share]');
    var toast = root.querySelector('[data-yy-sv-toast]');
    var toastTimer = null;
    function showToast() {
      toast.setAttribute('data-show', '');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.removeAttribute('data-show'); }, 1800);
    }
    /* alguns navegadores recusam navigator.clipboard se a página não estiver em foco naquele instante;
       esse jeito antigo (textarea + execCommand) funciona como reserva nesse caso. */
    function fallbackCopy(text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      return ok;
    }
    whatsapp.addEventListener('click', function (e) { e.stopPropagation(); });
    shareBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (!product) return;
      if (navigator.share) {
        navigator.share({ title: product.title, url: product.url }).catch(function () {});
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(product.url).then(showToast).catch(function () {
          if (fallbackCopy(product.url)) showToast();
        });
      } else if (fallbackCopy(product.url)) {
        showToast();
      }
    });

    var sheet = root.querySelector('[data-yy-sv-sheet]');
    var sheetPanel = root.querySelector('[data-yy-sv-sheet-panel]');
    var sheetGrid = root.querySelector('[data-yy-sv-sheet-grid]');
    sheet.addEventListener('click', function () { closeSheet(true); });
    sheetPanel.addEventListener('click', function (e) { e.stopPropagation(); });
    root.querySelector('[data-yy-sv-sheet-close]').addEventListener('click', function (e) {
      e.stopPropagation();
      closeSheet(true);
    });
    sheetGrid.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-vid]');
      if (!btn || btn.disabled) return;
      closeSheet(false);
      doAdd(parseInt(btn.getAttribute('data-vid'), 10));
    });

    var addBtn = root.querySelector('[data-yy-sv-add]');
    addBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (addBtn.hasAttribute('data-loading') || !product) return;
      var variants = product.variants || [];
      var available = variants.filter(function (v) { return v.available; });
      if (available.length > 1) { openSheet(); return; }
      var v = available[0] || variants[0];
      if (v) doAdd(v.id);
    });

    sv = {
      root: root,
      video: video,
      bars: root.querySelector('[data-yy-sv-bars]'),
      titleEl: root.querySelector('[data-yy-sv-title]'),
      muteIcon: root.querySelector('[data-yy-sv-mute] i'),
      heart: root.querySelector('[data-yy-sv-heart]'),
      whatsapp: whatsapp,
      cardImg: root.querySelector('[data-yy-sv-card-img]'),
      cardTitle: root.querySelector('[data-yy-sv-card-title]'),
      price: root.querySelector('[data-yy-sv-price]'),
      addBtn: addBtn,
      sheet: sheet,
      sheetGrid: sheetGrid
    };
  }

  function applyMute() {
    if (!sv) return;
    sv.video.muted = preferMuted;
    sv.muteIcon.className = preferMuted ? 'feather-volume-x' : 'feather-volume-2';
  }

  function updateProgress() {
    if (!sv || !sv.video.duration) return;
    var pct = Math.min(100, (sv.video.currentTime / sv.video.duration) * 100);
    var fill = sv.bars.children[index] && sv.bars.children[index].firstElementChild;
    if (fill) fill.style.width = pct + '%';
  }

  function renderBars() {
    var html = '';
    for (var i = 0; i < items.length; i++) {
      html += '<span class="yy-sv__bar" data-i="' + i + '"><span class="yy-sv__bar-fill"></span></span>';
    }
    sv.bars.innerHTML = html;
  }

  function markBars() {
    var bars = sv.bars.children;
    for (var i = 0; i < bars.length; i++) {
      bars[i].classList.toggle('yy-sv__bar--done', i < index);
      if (i !== index) {
        var fill = bars[i].firstElementChild;
        if (fill && i > index) fill.style.width = '0%';
      }
    }
  }

  /* video.play() é assíncrono: se pause() for chamado antes de a promessa resolver, o navegador
     pode ignorar o pause e o vídeo fica tocando escondido. Por isso todo pause() espera o play() em curso. */
  var playToken = 0;
  function safePause(video) {
    var pending = video.__yyPlayPromise;
    if (pending && pending.then) {
      pending.then(function () { video.pause(); }).catch(function () {});
    }
    video.pause();
  }

  function goTo(i) {
    if (i < 0) i = 0;
    if (i >= items.length) { close(); return; }
    index = i;
    var item = items[index];
    var myToken = ++playToken;
    safePause(sv.video);
    sv.video.src = pickSource(item.sources) || '';
    sv.video.poster = item.poster || '';
    sv.video.currentTime = 0;
    markBars();
    applyMute();
    var p = sv.video.play();
    sv.video.__yyPlayPromise = p;
    if (p && p.catch) {
      p.catch(function () {
        if (myToken !== playToken || !sv.root.hasAttribute('data-yy-sv-open')) return;
        preferMuted = true;
        applyMute();
        var p2 = sv.video.play();
        sv.video.__yyPlayPromise = p2;
        if (p2 && p2.catch) p2.catch(function () {});
      });
    }
  }

  /* ===== cartão do produto ===== */

  function priceBlockHtml(price, comparePrice) {
    var pct = 0;
    if (comparePrice > price) pct = Math.round((comparePrice - price) / comparePrice * 100);
    var html = '<div class="yy-sv__price-row"><span class="yy-sv__price">' + money(price) + '</span>';
    if (comparePrice > price) html += '<span class="yy-sv__compare">' + money(comparePrice) + '</span>';
    if (pct > 0) html += '<span class="yy-sv__off">-' + pct + '% OFF</span>';
    html += '</div>';
    if (price > 0 && product.pixPct > 0) {
      var pixCents = Math.round(price * (100 - product.pixPct) / 100);
      var instCents = Math.floor(price / product.instN);
      html += '<div class="yy-sv__pix">' + money(pixCents) + ' no Pix<span class="yy-sv__pix-tag">-' + product.pixPct + '% OFF</span></div>';
      html += '<div class="yy-sv__inst"><strong>' + product.instN + 'x de ' + money(instCents) + '</strong> sem juros</div>';
    }
    return html;
  }

  function renderCard() {
    sv.cardImg.src = product.image || '';
    sv.cardTitle.textContent = product.title || '';
    sv.price.innerHTML = priceBlockHtml(product.price, product.comparePrice);
  }

  function renderSide() {
    var wishlistActive = false;
    try {
      var list = JSON.parse(localStorage.getItem('wishlist') || '[]');
      wishlistActive = list.indexOf(product.handle) !== -1;
    } catch (e) {}
    sv.heart.className = 'yy-sv__side-btn wishlist ' + (wishlistActive ? 'active-wishlist' : 'wishlist-custom-action');
    sv.heart.setAttribute('data-handle', product.handle || '');
    var waMsg = 'Esse óculos é a sua cara! 😍 Vi e lembrei de você: ' + product.title + '\n' + product.url;
    sv.whatsapp.href = 'https://wa.me/?text=' + encodeURIComponent(waMsg);
  }

  function openSheet() {
    safePause(sv.video);
    var html = '';
    (product.variants || []).forEach(function (v) {
      html += '<button type="button" class="yy-sv__sheet-item" data-vid="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
        '<span class="yy-sv__sheet-photo"><img src="' + v.image + '" alt="' + esc(v.label) + '" loading="lazy"></span>' +
        '<span class="yy-sv__sheet-label">' + esc(v.label) + '</span></button>';
    });
    sv.sheetGrid.innerHTML = html;
    sv.sheet.setAttribute('data-open', '');
  }

  function closeSheet(resume) {
    sv.sheet.removeAttribute('data-open');
    if (resume && sv.root.hasAttribute('data-yy-sv-open')) {
      var p = sv.video.play();
      sv.video.__yyPlayPromise = p;
      if (p && p.catch) p.catch(function () {});
    }
  }

  function startDrawerSwiper() {
    var el = document.querySelector('ajax-cart .drawer-slider');
    if (!el || el.classList.contains('swiper-initialized') || typeof Swiper === 'undefined') return;
    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: { nextEl: '.arrow-next-drawer', prevEl: '.arrow-prev-drawer' },
      autoplay: { delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true },
      speed: 1000
    });
  }

  function openDrawer(sections) {
    var drawer = document.getElementById('ajaxcart');
    var fresh = sections['ajax-cart'] && new DOMParser().parseFromString(sections['ajax-cart'], 'text/html').querySelector('#ajaxcart');
    if (drawer && fresh) {
      drawer.innerHTML = fresh.innerHTML;
      startDrawerSwiper();
    }
    var count = sections['ajax-cart-icon'] && new DOMParser().parseFromString(sections['ajax-cart-icon'], 'text/html').querySelector('.bigcounter');
    if (count) {
      var els = document.querySelectorAll('.bigcounter');
      for (var i = 0; i < els.length; i++) els[i].innerHTML = count.innerHTML;
    }
    var mini = document.querySelector('.mini-cart');
    if (mini) {
      mini.classList.remove('is-empty');
      setTimeout(function () { mini.classList.add('animate', 'active'); }, 50);
    }
  }

  function doAdd(variantId) {
    if (!variantId) return;
    sv.addBtn.setAttribute('data-loading', '');
    sv.addBtn.disabled = true;
    var root2 = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root2 + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: 'ajax-cart,ajax-cart-icon' })
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.sections) throw new Error((data && data.description) || 'cart/add');
        openDrawer(data.sections);
        close(); /* fecha o vídeo e deixa o carrinho lateral já atualizado à mostra */
      })
      .catch(function (e) {
        console.error('yy-stories add:', e);
      })
      .then(function () {
        if (!sv) return;
        sv.addBtn.removeAttribute('data-loading');
        sv.addBtn.disabled = false;
      });
  }

  /* ===== abrir / fechar ===== */

  function open(list, startIndex, productData) {
    if (!sv) build();
    items = list;
    product = productData;
    sv.titleEl.textContent = (product && product.title) || '';
    sv.sheet.removeAttribute('data-open');
    if (product) {
      renderCard();
      renderSide();
    }
    renderBars();
    document.documentElement.style.overflow = 'hidden';
    sv.root.setAttribute('data-yy-sv-open', '');
    goTo(startIndex || 0);
  }

  function close() {
    if (!sv) return;
    playToken++;
    sv.root.removeAttribute('data-yy-sv-open');
    sv.sheet.removeAttribute('data-open');
    document.documentElement.style.overflow = '';
    safePause(sv.video);
    sv.video.removeAttribute('src');
    sv.video.load();
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-yy-story-open]');
    if (!btn) return;
    var wrap = btn.closest('[data-yy-stories]');
    var dataEl = wrap && wrap.querySelector('script[data-yy-stories-data]');
    var prodEl = wrap && wrap.querySelector('script[data-yy-stories-product]');
    if (!dataEl) return;
    var list, productData;
    try { list = JSON.parse(dataEl.textContent); } catch (e) { return; }
    try { productData = prodEl ? JSON.parse(prodEl.textContent) : null; } catch (e) { productData = null; }
    if (!list || !list.length) return;
    if (productData) productData.handle = wrap.getAttribute('data-handle') || '';
    open(list, parseInt(btn.getAttribute('data-index'), 10) || 0, productData);
  });
})();
